/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListSkillVersionsResult,
  ListSkillVersionsResult$inboundSchema,
} from "../components/listskillversionsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillVersionsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSkillVersionsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSkillVersionsSecurity = {
  option1?: ListSkillVersionsSecurityOption1 | undefined;
  option2?: ListSkillVersionsSecurityOption2 | undefined;
};

export type ListSkillVersionsRequest = {
  /**
   * The skill ID.
   */
  id: string;
  /**
   * Cursor for the next page of skill versions.
   */
  cursor?: string | undefined;
  /**
   * The number of skill versions to return per page.
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListSkillVersionsResponse = {
  result: ListSkillVersionsResult;
};

/** @internal */
export type ListSkillVersionsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSkillVersionsSecurityOption1$outboundSchema: z.ZodMiniType<
  ListSkillVersionsSecurityOption1$Outbound,
  ListSkillVersionsSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listSkillVersionsSecurityOption1ToJSON(
  listSkillVersionsSecurityOption1: ListSkillVersionsSecurityOption1,
): string {
  return JSON.stringify(
    ListSkillVersionsSecurityOption1$outboundSchema.parse(
      listSkillVersionsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSkillVersionsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSkillVersionsSecurityOption2$outboundSchema: z.ZodMiniType<
  ListSkillVersionsSecurityOption2$Outbound,
  ListSkillVersionsSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function listSkillVersionsSecurityOption2ToJSON(
  listSkillVersionsSecurityOption2: ListSkillVersionsSecurityOption2,
): string {
  return JSON.stringify(
    ListSkillVersionsSecurityOption2$outboundSchema.parse(
      listSkillVersionsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSkillVersionsSecurity$Outbound = {
  Option1?: ListSkillVersionsSecurityOption1$Outbound | undefined;
  Option2?: ListSkillVersionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSkillVersionsSecurity$outboundSchema: z.ZodMiniType<
  ListSkillVersionsSecurity$Outbound,
  ListSkillVersionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSkillVersionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSkillVersionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSkillVersionsSecurityToJSON(
  listSkillVersionsSecurity: ListSkillVersionsSecurity,
): string {
  return JSON.stringify(
    ListSkillVersionsSecurity$outboundSchema.parse(listSkillVersionsSecurity),
  );
}

/** @internal */
export type ListSkillVersionsRequest$Outbound = {
  id: string;
  cursor?: string | undefined;
  limit: number;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSkillVersionsRequest$outboundSchema: z.ZodMiniType<
  ListSkillVersionsRequest$Outbound,
  ListSkillVersionsRequest
> = z.pipe(
  z.object({
    id: z.string(),
    cursor: z.optional(z.string()),
    limit: z._default(z.int(), 20),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSkillVersionsRequestToJSON(
  listSkillVersionsRequest: ListSkillVersionsRequest,
): string {
  return JSON.stringify(
    ListSkillVersionsRequest$outboundSchema.parse(listSkillVersionsRequest),
  );
}

/** @internal */
export const ListSkillVersionsResponse$inboundSchema: z.ZodMiniType<
  ListSkillVersionsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListSkillVersionsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listSkillVersionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillVersionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillVersionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillVersionsResponse' from JSON`,
  );
}
